import videojs from 'video.js/dist/video.js';

// video.js 8 removed the extend helper that react-controls relies on.
// Recreate a minimal version that mirrors the legacy behavior so older
// component definitions still register correctly.
if (typeof videojs.extend !== 'function') {
	videojs.extend = function extend(SuperClass, definition = {}, statics = {}) {
		const SubClass = Object.prototype.hasOwnProperty.call(definition, 'constructor')
			? definition.constructor
			: function extendedComponent(...args) {
				SuperClass.apply(this, args);
			};

		// Preserve prototype chain so instanceof checks continue to work.
		SubClass.prototype = Object.create(SuperClass.prototype, {
			constructor: {
				value: SubClass,
				writable: true,
				configurable: true,
			},
		});

		// Keep a reference to the parent class (matches legacy implementation).
		SubClass.super_ = SuperClass;

		// Copy prototype members defined in the legacy extend call.
		Object.keys(definition).forEach(key => {
			if (key !== 'constructor') {
				SubClass.prototype[key] = definition[key];
			}
		});

		// Mirror static members from the parent onto the child.
		Object.getOwnPropertyNames(SuperClass).forEach(name => {
			if (!Object.prototype.hasOwnProperty.call(SubClass, name)) {
				const descriptor = Object.getOwnPropertyDescriptor(SuperClass, name);
				if (descriptor) {
					Object.defineProperty(SubClass, name, descriptor);
				}
			}
		});

		// Allow callers to provide additional statics.
		Object.keys(statics).forEach(name => {
			SubClass[name] = statics[name];
		});

		return SubClass;
	};
}

export default videojs;
